<template>
  <ul>
    <li
      v-for="item in finalList"
      :key="item.id"
      @click="toggle(item)"
    >
      <span
        class="is--checkbox"
        :class="{'is--check': item.checked}"
      >
        <i class="ri-check-line"></i>
      </span>
      <span class="is--tag">
        {{ item.title }}
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['list', 'checked'],
  data() {
    return {
      finalList: this.list
    }
  },
  methods: {
    toggle(item) {
      item.checked = !item.checked;

      this.$emit('change', this.finalList)
    }
  }
}
</script>

<style lang="scss" scoped>
  ul {
    list-style: none;
    li {
      display: flex;
      align-items: center;
      margin: 24px 0;
      cursor: pointer;
      span.is--checkbox {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 16px;
        background: var(--label-quarternary);
        border: 1px solid var(--label-quarternary);
        i {
          font-size: 24px;
          vertical-align: middle;
          opacity: 0;
          color: var(--light-01);
        }
        &.is--check {
          background: var(--accent-blue);
          i {
            opacity: 1;
          }
        }
      }
      span.is--tag {
        color: var(--light-01);
        font-feature-settings: 'zero' on;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        background: var(--label-tetriary);
        border-radius: 8px;
        padding: 2px 8px;
      }
    }
  }

  @media (max-width: 425px) {
    ul {
      li {
        &:first-child {
          margin-top: 0;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
</style>
